// Front-end feature flags. Edit values here to toggle whole surfaces
// without touching their individual callsites. Server-side behaviour is
// independent — the routes still exist and respond; we just hide the
// affordances in the UI.

// AI Preview, AI Learning admin page, AI reference image uploads on
// garments, and the per-garment AI Preview admin toggle. Disabled while
// the realism generation flow is being re-evaluated.
export const AI_TOOLS_ENABLED = false

// Per-location "Display mockup" upload card on the Garment Detail page.
// Hidden by request 2026-05-29 — the product-level mockup still feeds
// the customer-facing Designer; this only affected per-location overrides
// (e.g. a back-of-shirt photo for the Back print zone).
export const DISPLAY_MOCKUP_PER_LOCATION_ENABLED = false
